import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1500;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 41, 52, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  width: 600px;
  height: 210px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 32px 24px 32px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 24px;
  top: 20px;
  background: none;
  border: none;
  font-size: 20px;
  color: #AEB8C4;
  cursor: pointer;
`;

export const Title = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #1B2028;
  margin-bottom: 6px;
  text-align: center;
  padding-top: 30px;
  white-space: nowrap;
  max-width: 100%;
`;

export const Subtitle = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  color: #5A6C87;
  text-align: center;
  margin-bottom: 28px;
`;

export const ProgressWrapper = styled.div`
  width: 85%;
  display: flex;
  justify-content: center;
`; 